import { EmojiPicker, IconButton, Popover } from '@components'
import type { MessageReaction } from '@here/api'
import { useService } from 'solid-services'
import { userId } from '@state'
import { SmilePlus } from 'lucide-solid'
import { Portal } from 'solid-js/web'
import { useUpsert } from '../../state'

type Reaction = Pick<MessageReaction, 'emoji' | 'created_by'>

interface ReactionsProps {
	reactions?: Reaction[]
	messageId: string
}

export default function (props: ReactionsProps) {
	const { setUpsertMessageReaction } = useService(useUpsert)()

	const upsertReaction = (emoji: string) =>
		setUpsertMessageReaction({
			emoji,
			message_id: props.messageId,
			created_by: userId()!,
		})

	return (
		<>
			<Popover.Root
				positioning={{
					offset: {
						mainAxis: -15,
					},
				}}
			>
				<Popover.Trigger
					asChild={(props) => (
						<>
							<IconButton
                {...props}
								height="20px"
								minWidth="20px"
								size="xs"
								variant="ghost"
								type="button"
							>
								<SmilePlus width='15px' height='15px' />
							</IconButton>
						</>
					)}
				/>
				<Portal>
					<Popover.Positioner>
						<Popover.Content p={0}>
							<Popover.Arrow>
								<Popover.ArrowTip />
							</Popover.Arrow>
							<EmojiPicker onSelect={upsertReaction} />
						</Popover.Content>
					</Popover.Positioner>
				</Portal>
			</Popover.Root>
		</>
	)
}
